// export function log(...val) {
//   if (window.dev) {
//     let str = ''
//     for(let i in val) {
//       str+=val[i] + " "
//     }
//     console.log("log:" + str)
//   }
//
// }

function isObject(val) {
  return typeof val === 'object' && !Array.isArray(val) && val !== null;
}

export function log(gameObj, ...arr) {
  const debugPlayer = arr[0];
  let str = debugPlayer + " ";
  const playerBetTurn = gameObj.playerBetTurn;

  if ((debugPlayer === 'human' && playerBetTurn === 'human') ||
      (debugPlayer === 'computer' && playerBetTurn === 'computer') ||
      (debugPlayer === 'both' && debugPlayer !== 'waithuman' && debugPlayer !== 'waitcomputer')) {
    
    if (debugPlayer === 'both') {
      str = gameObj.playerBetTurn + " ";
    }

    for (let i = 1; i < arr.length; i++) {
      if (isObject(arr[i]) || Array.isArray(arr[i])) {
        for (let j in arr[i]) {
          str += (debugPlayer === 'both' ? j : "") + JSON.stringify(arr[i][j], null, 2);
        }
      } else {
        str += arr[i] + " ";
      }
    }
    console.log(str);
  }
}